import { Send } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";

interface SendingAnimationProps {
    isSending: boolean;
}

const SendingAnimation: React.FC<SendingAnimationProps> = ({ isSending }) => {
    return (
        <AnimatePresence>
            {isSending && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ y: -50, opacity: 0, transition: { duration: 0.5 } }} // Fly away effect
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(255, 255, 255, 0.7)",
                        zIndex: 10,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                >
                    <motion.div
                        animate={{
                            x: [0, 10, -10, 0], // Side-to-side movement
                            opacity: [1, 0.7, 1], // Fades in/out
                        }}
                        transition={{
                            duration: 0.6,
                            repeat: Infinity,
                            ease: "easeInOut",
                        }}
                    >
                        <Send fontSize="large" color="primary" />
                    </motion.div>
                    <Typography variant="h6">Sending...</Typography>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default SendingAnimation;
